import React, { useEffect, useState } from 'react';
import moment from 'moment';
import './style.css';
import { getFile } from '@opu/utils';
import { useTranslation } from 'react-i18next';
import AxiosInstance from '../../../helpers/AxiosInstance';
import Swal from 'sweetalert2';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import { isUUID } from 'class-validator';

const Text = ({ text, type = null, id = null, role = null, maxLength = 20, active = true }) => {
  const { t, i18n } = useTranslation();

  const [value, setValue] = useState(null);
  useEffect(() => {
    if (type === 'switcherContract') {
      if (text === 'ENABLED') setValue(true);
      else setValue(false);
    } else setValue(text);
  }, []);

  const enableOrDisableStudentAccount = () => {
    if (role !== 'ESTABLISHMENT_USER') {
      Swal.fire({
        title: t('swal.are_you_sure'),
        text: t('swal.student.update_status'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: t('swal.no'),
        confirmButtonText: t(value ? 'swal.student.disable_status' : 'swal.student.activate_status'),
      }).then((result) => {
        if (result.isConfirmed) {
          AxiosInstance.patch('/student/' + id + '/activate', {
            isActivated: !value,
          }).then(() => {
            setValue(!value);
          });
        }
      });
    }
  };

  const activateOrDeactivateContract = () => {
    if (active || role !== 'ESTABLISHMENT_USER') {
      Swal.fire({
        title: t('swal.are_you_sure'),
        text: t('swal.contract.update_status'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: t('swal.no'),
        confirmButtonText: t(value ? 'swal.contract.disable_status' : 'swal.contract.activate_status'),
      }).then((result) => {
        if (result.isConfirmed) {
          AxiosInstance.patch('/contract/' + id, {
            status: value ? 'DISABLED' : 'ENABLED',
          })
            .then((response) => {
              setValue(!value);
            })
            .catch((error) => {
              if (error.data.message && error.data.message[0]) Swal.fire(t(`contract.${error.data.message[0]}`), '', 'error');
            });
        }
      });
    }
  };

  if (Array.isArray(text)) {
    if (type === 'contract_status') {
      if (text.length > 0 && text[0] === 'ENABLED') return <span className="badge badge-success">{t('ENABLED')}</span>;
      else return <span className="badge badge-warning">{t('DISABLE')}</span>;
    }

    return text.slice(0, 3).map((txt) => <span className="badge badge-secondary">{txt}</span>);
  } else {
    if (type === 'verified_status') {
      if (text) return <span className="badge badge-success">Oui</span>;
      else return <span className="badge badge-warning">Non</span>;
    }
    if (text !== '') {
      if (type === 'date') {
        text = new Date(text);
        text = moment(text).format('DD/MM/YYYY');
      } else if (type === 'time') {
        text = new Date('January 1, ' + text);
        text = moment(text).format('HH:mm');
      } else if (type === 'dateTime') {
        text = new Date(text);
        text = moment(text).format('DD/MM/YYYY HH:mm');
      } else if (type === 'actionLog') {
        text = t(`action-log.action.${text}`);
      } else if (type === 'actionLogMessage') {
        const split = text.split('<<SEPARATOR>>');
        return (
          <div>
            <span className="limited-text">{t(`action-log.action.${split[0].trim()}`)}</span>{' '}
            <b className="font-weight-bold">{split[1].trim()}</b>
          </div>
        );
      } else if (type === 'duree') {
        text = new Date('January 1, ' + text);
        text = moment(text).format('HH:mm');
        text = text.replace(':', 'H') + 'min';
      } else if (type === 'image') {
        return <img src={getFile('book', text)} alt="cover" style={{ width: 50, height: 30 }} />;
      } else if (type === 'isActivated') {
        return <ToggleSwitch id={'newsletter-' + id} checked={value} onChange={enableOrDisableStudentAccount} />;
      } else if (type === 'switcherContract') {
        if (role === 'ESTABLISHMENT_USER' || !active) {
          if (value) return <span className="badge badge-success">{t('ENABLED')}</span>;
          else return <span className="badge badge-warning">{t('DISABLE')}</span>;
        } else {
          return <ToggleSwitch id={'status-' + id} checked={value} onChange={activateOrDeactivateContract} />;
        }
      } else if (type === 'rating') {
        text = text % 2 !== 0 ? text.toFixed(1) : text;
      } else if (type === 'author_display') {
        if (text) return <span className="badge badge-success">{t('author.show')}</span>;
        else return <span className="badge badge-warning">{t('author.hide')}</span>;
      }
    } else text = '-';

    if (typeof text === 'string' && !['date', 'time', 'dateTime', 'rating'].includes(type)) {
      return (
        <span className="limited-text" data-bs-toggle="tooltip" data-bs-placement="top" title={text}>
          {text}
        </span>
      );
    }
    return <span>{text}</span>;
  }
};

export default Text;
